import {useState} from "react";
import {useDispatch} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import "./startCervo.scss";
import Headerbutton from "../../component/headerButton";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import variables from "../../../../_constants/variables";

import luxs from "assets/img/luxluz.png";
import {Button} from "antd";
import {ArrowRightOutlined, LeftOutlined} from "@ant-design/icons";
import {history} from "../../../../_helpers";
import { MdPlayCircleFilled } from "react-icons/md";

// import {MdPlayCircleFilled} from "react-icons";
function FinishCervo(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);

    const [video, setVideo] = useState(false)
    const [isEnd, setEnd] = useState(false);


    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (
        <>
            {!isEnd &&
              <div className={"backGroundFinishCervo wrapper history"}>
                  <div className={"insideCervo boxed"}>
                      <Headerbutton saveAndContinue={saveAndContinue} />
                  </div>
                  <div className={"container-history boxed"}>
                      <img className={"character character--flip character--lux"} src={luxs} alt={""} />
                      <div className={"container-dialogue"}>
                          <div className={"dialogue-content-text"}>
                              <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.finishcervo').replace("#name#", user.name.trim())}}></p>
                          </div>
                          <div className={"dialogue-buttons"}>
                              <div className="left margin-right-auto">
                                  <Button
                                    icon={<LeftOutlined />}
                                    type={"link"}
                                    onClick={() => history.push("/admin/cervo-game")}
                                  >
                                      {t("atras")}
                                  </Button>
                              </div>
                              <div className="right">
                                  <Button onClick={() => history.push("/admin/assessment")}
                                          className="primaryButton"
                                  >
                                      {t("cervo.irahome")}
                                  </Button>
                                  <Button icon={<ArrowRightOutlined />}
                                          onClick={() => setEnd(true)}
                                          type={"primary"}
                                          className="primaryButton"
                                  >
                                      {t("cervo.verfinal")}
                                  </Button>
                              </div>
                          </div>
                          <p className={"dialogue-name"}>
                              <strong>LUX</strong>
                          </p>
                      </div>
                  </div>
              </div>
            }
            {isEnd &&
              <div className={"backGroundFinishCervo2 wrapper history"}>
                  <div className={"video-overlay"}></div>
                  <div className={"container-history container-history--video boxed"}>
                      {!video &&
                        <div className={"history-play-video"}>
                            <MdPlayCircleFilled onClick={() => setVideo(true)}/>
                            <p onClick={() => setVideo(true)}>{t("ceiba.vervideo")}</p>
                        </div>
                      }
                      {video &&
                        <div className={"history-view-video"}>
                            <iframe id="kaltura_player"
                                    className={"history-view-video-iframe"}
                                    src="https://cdnapisec.kaltura.com/p/2206521/sp/220652100/embedIframeJs/uiconf_id/42503771/partner_id/2206521?iframeembed=true&playerId=kaltura_player&entry_id=1_q1wgik7d&flashvars[streamerType]=auto&amp;flashvars[autoPlay]=true&amp;flashvars[localizationCode]=es&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_oopn34hi"
                                    width="400" height="285" allowFullScreen webkitallowfullscreen mozAllowFullScreen
                                    allow="autoplay; fullscreen *; encrypted-media *"
                                    sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
                                    frameBorder="0" title="DOKIA_Outro">

                            </iframe>
                        </div>
                      }
                      <div className={"container-dialogue"}>
                          <div className={"dialogue-buttons"}>
                              <div className="left margin-right-auto">
                                  <Button
                                    type={"link"}
                                    onClick={() => setEnd(false)}
                                    style={{backgroundColor: "white", paddingLeft: 15}}
                                  >
                                      {t("atras")}
                                  </Button>
                              </div>
                              <div className="right">
                                  <Button icon={<ArrowRightOutlined />}
                                          onClick={() => history.push("/admin/assessment")}
                                          type={"primary"}
                                          className="primaryButton"
                                  >
                                      {t("tek.irahome")}
                                  </Button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            }

        </>
    )
}
export default withTranslation()(FinishCervo);
